import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
// import {
//   addOMAdminLocationAsync,
//   deleteOMAdminLocationAsync,
//   editOMAdminLocationAsync,
//   getOMAdminLocationAsync,
// } from "../../../store/services/orderManagementService";
const AdminLocation = () => {
  const dispatch = useDispatch();
  const {
    getOMAdminLocationStatus,
    getOMAdminLocationError,
    getOMAdminLocationData,
    addOMAdminLocationStatus,
    addOMAdminLocationData,
    addOMAdminLocationError,

    editOMAdminLocationStatus,
    editOMAdminLocationError,
    editOMAdminLocationData,

    deleteOMAdminLocationData,
    deleteOMAdminLocationStatus,
    deleteOMAdminLocationError,
  } = useSelector((state) => state.om);

  // useEffect(() => {
  //   dispatch(getOMAdminLocationAsync());
  // }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMAdminLocationData?.length
    ? getOMAdminLocationData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedAdminLocation, setSelectedAdminLocation] = useState();
  const [addAdminLocationMode, setAddAdminLocationMode] = useState(false);
  const [addAdminLocationData, setAddAdminLocationData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedAdminLocation", selectedAdminLocation);
  // console.log("editData", editData);
  // useEffect(() => {
  //   if (addOMAdminLocationStatus === asyncStatus.SUCCEEDED) {
  //     setAddAdminLocationMode(false);
  //     setSaveDisabled(true);
  //     setAddAdminLocationData();
  //   }
  // }, [, addOMAdminLocationStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    // dispatch(deleteOMAdminLocationAsync(selectedAdminLocation?.term_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  // useEffect(() => {
  //   if (deleteOMAdminLocationStatus === asyncStatus.SUCCEEDED || deleteOMAdminLocationStatus === asyncStatus.ERROR ) {
  //     setOpen(false);
  //     setSelectedAdminLocation();
  //   }
  // }, [, deleteOMAdminLocationStatus]);
  // useEffect(() => {
  //   if (editOMAdminLocationStatus === asyncStatus.SUCCEEDED) {
  //     setSelectedAdminLocation();
  //     setEditMode(false);
  //     setEditData()
  //   }
  // }, [, editOMAdminLocationStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this location?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Location"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Location
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddAdminLocationMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addAdminLocationMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addAdminLocationMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddAdminLocationMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addAdminLocationMode || !selectedAdminLocation}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMAdminLocationStatus === asyncStatus.LOADING ||
                  editOMAdminLocationStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                // onClick={() => {
                //   if (addAdminLocationData) {
                //     dispatch(addOMAdminLocationAsync(addAdminLocationData));
                //   } else if (editMode) {
                //     let a;
                //     a = { ...selectedAdminLocation, ...editData };
                //     delete a.id;
                //     dispatch(editOMAdminLocationAsync(a));
                //   }
                // }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "term_id", headerName: "Location ID", flex: true },
                  { field: "term_name", headerName: "Location", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedAdminLocation(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMAdminLocationStatus === asyncStatus.IDLE ||
                  getOMAdminLocationStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addAdminLocationMode ? (
              <InputWithBtnLayoutComp
              error={addOMAdminLocationError}
                inputArray={[
                  {
                    label: "Location:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddAdminLocationData({
                            ...addAdminLocationData,
                            term_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddAdminLocationData({
                            ...addAdminLocationData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedAdminLocation ? (
              <InputWithBtnLayoutComp
              error={editOMAdminLocationError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedAdminLocation?.term_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "AdminLocation:",
                    comp: (
                      <InputComp
                        key={selectedAdminLocation?.term_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            term_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedAdminLocation?.term_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedAdminLocation?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedAdminLocation?.is_active || editData?.is_active}
                        defaultChecked={selectedAdminLocation?.is_active || editData?.is_active}
                        // checked={selectedAdminLocation?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any location</Typography>
              <Typography color={"red"} fontSize={12}>{getOMAdminLocationError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedAdminLocation(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedAdminLocation(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default AdminLocation;
